import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "studict_session_token";

export function setSessionToken(token) {
  if (token) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch { /* ignore */ }
  }
}

export function clearSessionToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
}

export function getSessionToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

const instance = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Defence-in-depth: when the browser drops cookies (Samsung Browser, in-app
// WebViews, Brave Shields strict), this Bearer token from localStorage keeps
// the user signed in. The backend accepts either source.
instance.interceptors.request.use((config) => {
  const token = getSessionToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Auto-capture the token from any auth response that includes it.
instance.interceptors.response.use(
  (response) => {
    const data = response?.data;
    if (data && typeof data === "object" && typeof data.session_token === "string") {
      setSessionToken(data.session_token);
    }
    return response;
  },
  (error) => {
    // On 401 from any endpoint, the stored token is stale — wipe it so the
    // next page load shows the login screen instead of looping into errors.
    if (error?.response?.status === 401) {
      clearSessionToken();
    }
    return Promise.reject(error);
  },
);

export default instance;
